import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "../../components/Button";
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from "../../components/Modal";
import {
  closeModal,
  cloneEmailModule,
  emailTemplatesList,
  gotoUrl,
} from "../../actions";
import styles from "../../components/Modal.module.css";

export class CloneEmailModal extends Component {
  constructor(props) {
    super(props);
    this.clone = this.clone.bind(this);
    this.nameRef = createRef();
  }

  componentDidMount() {
    if (this.nameRef?.current) {
      this.nameRef.current.focus();
    }
  }

  clone(e) {
    if (e) {
      e.preventDefault();
    }

    const { accountId, emailModule } = this.props;

    this.props
      .cloneEmailModule(accountId, emailModule.id, {
        name: this.nameRef?.current.value,
      })
      .then((data) => {
        const nextId = data.data.id;
        return this.props.gotoUrl(
          "/clients/" + accountId + "/email-modules/" + nextId
        );
      })
      .then(this.props.closeModal);
  }

  render() {
    const { emailModule } = this.props;

    return (
      <Modal>
        <ModalHeader>Clone Email Module</ModalHeader>
        <ModalContent>
          <form onSubmit={this.clone}>
            <div className={styles.flex}>
              <label>Name</label>
              <input
                ref={this.nameRef}
                autofocus="true"
                defaultValue={`${emailModule.name} copy`}
              />
            </div>
          </form>
        </ModalContent>
        <ModalFooter>
          <Button type="link" onClick={this.props.closeModal}>
            Cancel
          </Button>
          <Button onClick={this.clone}>Clone</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

CloneEmailModal.propTypes = {
  cloneEmailModule: PropTypes.func.isRequired,
  emailTemplatesList: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  emailTemplates: PropTypes.array.isRequired,
  gotoUrl: PropTypes.func.isRequired,
  accountId: PropTypes.string.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const { params } = state.modal;
  const { accountId, id } = params;
  const emailModule = state.entities.emailModule[id];

  return {
    accountId,
    id,
    emailModule,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  closeModal,
  cloneEmailModule,
  emailTemplatesList,
  gotoUrl,
})(CloneEmailModal);
